export const dataMapFrom = <T, R extends string | number | symbol>(
  data: T[],
  idFor: (value: T) => R,
): Record<R, T> => {
  const map: Record<R, T> = {} as any;
  data?.forEach((value) => {
    map[idFor(value)] = value;
  });

  return map;
};
